import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { TRIGGER_ICON_BY_TYPE } from "constants/flowDesigner";

export const NewFlowTrigger = ({ trigger, onClick, isUsed }) => {
  const IconComponent = TRIGGER_ICON_BY_TYPE[trigger.type];

  return (
    <SoftBox
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        position: "relative",
        textAlign: "center"
      }}
    >
      <SoftButton
        color={isUsed ? "success" : "primary"}
        type="button"
        onClick={onClick}
        sx={{
          color: "#FFFFFF",
          fontSize: "10px",
          inset: ".5rem .5rem auto auto",
          minHeight: "0",
          minWidth: "0",
          padding: ".5rem .75rem",
          position: "absolute"
        }}
      >
        {isUsed ? "Remove" : "Add"}
      </SoftButton>
      <IconComponent
        className="flow-trigger-icon"
        width="40px"
        height="40px"
        style={{ marginBottom: ".25rem" }}
      />
      <SoftTypography
        className="white-to-dark"
        sx={{
          fontWeight: "600",
          fontSize: "14px",
          marginBottom: ".5rem"
        }}
      >
        {trigger.label}
      </SoftTypography>
      <SoftTypography
        color="text"
        sx={{
          fontSize: "13px",
          fontWeight: "500",
          lineHeight: "1.25"
        }}
      >
        {trigger.description}
      </SoftTypography>
    </SoftBox>
  );
};
